export const URL_SEARCHER = (() => {
    switch (process.env.ENVIRONMENT) {
        case 'PDN':
            return 'https://lk9tx38w5a.execute-api.us-east-1.amazonaws.com/pdn/search/api/v1/search-article';
        case 'QA':
            return 'https://153ql605pj.execute-api.us-east-1.amazonaws.com/qa/search/api/v1/search-article';
        default:
            return 'https://nlhip4kxl4.execute-api.us-east-1.amazonaws.com/dev/search/api/v1/search-article';
    }
})();

export const URL_ARTICLE_RATING = (() => {
    switch (process.env.ENVIRONMENT) {
        case 'PDN':
            return 'https://lk9tx38w5a.execute-api.us-east-1.amazonaws.com/pdn/rating/api/v1/rating-article';
        case 'QA':
            return 'https://153ql605pj.execute-api.us-east-1.amazonaws.com/qa/rating/api/v1/rating-article';
        default:
            return 'https://nlhip4kxl4.execute-api.us-east-1.amazonaws.com/dev/rating/api/v1/rating-article';
    }
})();

const URL_INTEGRACIONES =
    process.env.ENVIRONMENT === 'PDN'
        ? 'https://integraciones.comfama.com'
        : 'https://integracionesqa.comfama.com';

export const URL_TOKEN = `${URL_INTEGRACIONES}/tokenizer/accessToken`;

export const URL_CHATBOT = `${URL_INTEGRACIONES}/tran/TRA-CX-AsistenteCentroAyudaDigital/`;
